/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_GreenInputs */

const en_booking_color_green = /** @type {(inputs: Booking_Color_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green`)
};

const pl_booking_color_green = /** @type {(inputs: Booking_Color_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielony`)
};

/**
* | output |
* | --- |
* | "Green" |
*
* @param {Booking_Color_GreenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_green = /** @type {((inputs?: Booking_Color_GreenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_GreenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_green(inputs)
	return en_booking_color_green(inputs)
});